<table [dataSource]="adminTableService.dataSource" class="fc-table" mat-table
       aria-describedby="List of Sites" cdkDropList
       cdkDropListLockAxis="x"
       cdkDropListOrientation="horizontal" (cdkDropListDropped)="adminTableService.reorderColumns($event)">

  @for (exportColumn of adminTableService.columnData; track exportColumn) {
    @if (exportColumn.templateColumn !== null) {
      <ng-container [matColumnDef]="exportColumn.templateColumn">
        <th cdkDragBoundary="mat-mdc-header-row" cdkDrag cdkDragLockAxis="x" scope="col" *matHeaderCellDef
            mat-header-cell [class]="exportColumn.columnClass || 'column-small'">
          <div class="edit-icons">
            <div cdkDragHandle>
              <fa-icon [icon]="['fal', 'arrows-up-down-left-right']" class="drag-handle"></fa-icon>
            </div>
            <fa-icon [icon]="['far', 'trash']" (click)="adminTableService.removeColumn(exportColumn.templateColumn)"
                     class="drag-handle"></fa-icon>
          </div>
          @if (exportColumn.templateColumn == 'select') {
            <mat-checkbox
              (change)="$event ? adminTableService.masterToggle() : null"
              [checked]="adminTableService.selection.hasValue() && adminTableService.isAllSelected()"
              [indeterminate]="adminTableService.selection.hasValue() && !adminTableService.isAllSelected()"></mat-checkbox>
          }
          <div [class.header-with-sort]="exportColumn.sortable || exportColumn.field">
            <span (click)="exportColumn.field ? quickFilter.emit(exportColumn) : null">
            @if (exportColumn.field) {
              <fa-icon [icon]="['far', 'filter']"></fa-icon>
            }
              {{ exportColumn.headerLabel || exportColumn.label }}
              </span>
            @if (exportColumn.sortable ?? exportColumn.field) {
              <fc-sort-icon
                (pointerdown)="onSortDown($event)"
                (mousedown)="onSortDown($event)"
                (pointerup)="onSortUp($event, exportColumn.field)"
                (mouseup)="onSortUp($event, exportColumn.field)"
                [column]="exportColumn.field" [sortBy]="adminTableService.sortBy()"
                [sortStates]="adminTableService.sortStates"></fc-sort-icon>
            }
          </div>
        </th>
        <td (click)="exportColumn.routerLink ? $event.stopPropagation() : null;" *matCellDef="let row" mat-cell
            [class]="exportColumn.columnClass || 'column-small'">
          @if (exportColumn.routerLink) {
            <a
              (click)="$event.stopPropagation()"
              [routerLink]="exportColumn.routerLink(row)"
              target="_blank"
              rel="noopener noreferrer">
              {{ exportColumn.rowValue(row) }}
            </a>
          } @else if (exportColumn.iconMap) {
            @if (exportColumn.iconMap[exportColumn.rowValue(row)]) {
              <div
                class="icon">
                <fa-icon [icon]="['far', exportColumn.iconMap[exportColumn.rowValue(row)].icon]"
                         [class]="exportColumn.iconMap[exportColumn.rowValue(row)].class"></fa-icon>
              </div>
            }
          } @else if (exportColumn.rowValue) {
            {{ exportColumn.rowValue(row)  | columnTransform: exportColumn.rowValuePipe }}
          } @else if (exportColumn.templateColumn == 'select') {
            <mat-checkbox
              (change)="$event ? adminTableService.selection.toggle(row) : null"
              (click)="$event.stopPropagation()"
              [checked]="adminTableService.selection.isSelected(row)"></mat-checkbox>
          }
          @if (exportColumn.rowSubtitle) {
            <div
              class="row-subtitle">{{ exportColumn.rowSubtitle(row)  | columnTransform: exportColumn.rowSubtitlePipe }}
            </div>
          }
        </td>
      </ng-container>
    }
  }
  <tr *matHeaderRowDef="adminTableService.displayedColumns(); sticky: true" mat-header-row></tr>
  <tr
    (click)="clickRow && clickRow.emit(row)"
    *matRowDef="let row; columns: adminTableService.displayedColumns()"
    [ngClass]="row.isTooBig || row.isTooSmall ? 'alert' : null"
    mat-row></tr>
</table>

